import './status.scss';

import { Outlet } from "react-router-dom";

import { FilterStatusProvider } from "./filter-status/filter-status.context";

export function Status() {
  return (
    <div id="ShellStatus" className="status">
       <FilterStatusProvider>
        <Outlet />
      </FilterStatusProvider>
    </div>
  );
}

export default Status;
